// import Popup from "./components/Popup";

export default () => {
	// const videos: HTMLElement[] = Array.from(
	// 	document.querySelectorAll(".has-video")
	// );

	// if (!videos) return;

	// videos.map((videoWrapper: HTMLElement) => Popup(videoWrapper));

	let videos = document.querySelectorAll('div.video') as NodeListOf<HTMLElement>
	videos.forEach(video => {
		let youtube = video.querySelector('iframe')
		let poster = video.querySelector('figure')
		let autoplay = video.dataset.autoplay
		video.onclick = () => {
			let src = youtube?.getAttribute('src')
			poster?.classList.add('play')
			youtube?.setAttribute('src', src + '&autoplay=1&rel=0')
		}
		if ( autoplay ) {
			let src = youtube?.getAttribute('src')
			poster?.classList.add('play')
			youtube?.setAttribute('src', src + '&autoplay=1&rel=0')
		}
	})
};
